import React, { PropsWithChildren } from 'react';
import { Content, Description, HeadingColumn } from './style';

type DetailsPageDescriptionProps = {
  title: string;
};

export const DetailsPageDescription = ({
  children,
  title,
}: PropsWithChildren<DetailsPageDescriptionProps>): JSX.Element => {
  return (
    <Content>
      <HeadingColumn>{title}</HeadingColumn>
      <Description>{children}</Description>
    </Content>
  );
};
